import { companyDetailsConstants } from "../../_constants";

const initialState = {};

export const get_company_details_by_id_reducer  = (state = initialState, action) => {
  switch (action.type) {
    case companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_SUCCESS:
      return {
    
        companyInformationData: action.payload,
      };
    case companyDetailsConstants.COMPANY_DETAILS_BY_ID_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const get_company_list_detail_reducer= (state = initialState, action) => {
  switch (action.type) {
    case companyDetailsConstants.COMPANY_LIST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case companyDetailsConstants.COMPANY_LIST_ACTION_SUCCESS:
      return {  
        type: "alert-success", 
        companyListData: action.payload,
      };
    case companyDetailsConstants.COMPANY_LIST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};



export const get_company_jobs_lists_reducer  = (state = initialState, action) => {
  switch (action.type) {
    case companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_SUCCESS:
      return {   
        companyJobsListData: action.payload,
      };
    case companyDetailsConstants.COMPANY_JOBS_LIST_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};